import { render, staticRenderFns } from "./EditCampaignCollectionComponent.vue?vue&type=template&id=6df7227e&"
import script from "./EditCampaignCollectionComponent.vue?vue&type=script&lang=js&"
export * from "./EditCampaignCollectionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports